/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {registerSmsJanus} from '../api'

export const useMutationRegisterSmsJanus = createReactQueryMutationHook('registerSmsJanus', registerSmsJanus)
